export const MAX_RESOURCE_TYPE_COUNT = 100;
export const MAX_RESOURCE_ITEM_COUNT = 10;

export const RESOURCE_TYPES_PAGE_SIZE = MAX_RESOURCE_TYPE_COUNT;
export const RESOURCES_PAGE_SIZE = MAX_RESOURCE_TYPE_COUNT * MAX_RESOURCE_ITEM_COUNT;
